import i18n from "@/i18n";
import type { IMenuRoute } from "@/models/routes";

export const leadOverview = [
  {
    label: "_.overview",
    to: (vm: any) => {
      return {
        name: "adminLeadOverview",
        params: vm.$route.params
      };
    }
  },
  {
    label: "_.tickets",
    to: (vm: any) => {
      return {
        name: "adminLeadSupportTickets",
        params: vm.$route.params
      };
    }
  },
  {
    label: "_.email_history",
    to: (vm: any) => {
      return {
        name: "adminLeadEmailHistory",
        params: vm.$route.params
      };
    }
  }
];

export function ticketsTabigation(): (IMenuRoute & { exact?: boolean })[] {
  return [
    {
      label: i18n.t("_.active_tickets"),
      to: { name: "admin__leadActiveSupportTickets" }
    },
    {
      label: i18n.t("_.closed_tickets"),
      to: {
        name: "admin__leadClosedSupportTickets"
      }
    }
  ];
}
